<ng-container *transloco="let t">
  <section class="featured-specs-selector" [class.wide]="(biggerThan$ | async)?.mobileS">
    <span class="fixed-space-4" aria-hidden="true"></span>

    <ng-container *ngIf="product">
      <nav class="nav">
        <div
          class="small link"
          (click)="selectTested()"
          [class.selected]="selectedComponent === 'tested'">
          <span [class.bigger]="(biggerThan$ | async)?.mobileS">
            {{ t('label_inspection_points') }}
          </span>
        </div>
        <span class="item fixed-space-12" aria-hidden="true"></span>
        <div
          class="small link"
          (click)="selectDetails()"
          [class.selected]="selectedComponent === 'details'">
          <span [class.bigger]="(biggerThan$ | async)?.mobileS">
            {{ t('action_view_details') }}
          </span>
        </div>
        <span class="item fixed-space-12" aria-hidden="true"></span>

        <div
          class="link small"
          (click)="selectAbout()"
          [class.selected]="selectedComponent === 'about'">
          <span [class.bigger]="(biggerThan$ | async)?.mobileS">
            {{ t('category_about') }}
          </span>
        </div>
      </nav>

      <section class="content">
        <app-featured-description-card
          *ngIf="selectedComponent === 'about'"
          [product]="product"
          displayMode="icon"></app-featured-description-card>

        <app-featured-verified-specs-card
          *ngIf="selectedComponent === 'tested'"></app-featured-verified-specs-card>

        <app-featured-specs-card
          *ngIf="selectedComponent === 'details'"
          [metadata]="product.rawMetadata"></app-featured-specs-card>
      </section>
    </ng-container>
  </section>
</ng-container>
